<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'empty') {
    <app-empty-layout></app-empty-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->
@if (layout === 'centered') {
    <app-centered-layout></app-centered-layout>
}

<!-- Enterprise -->
@if (layout === 'enterprise') {
    <app-enterprise-layout></app-enterprise-layout>
}

<!-- Material -->
@if (layout === 'material') {
    <app-material-layout></app-material-layout>
}

<!-- Modern -->
@if (layout === 'modern') {
    <app-modern-layout></app-modern-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Classic -->
@if (layout === 'classic') {
    <app-classic-layout></app-classic-layout>
}

<!-- Classy -->
@if (layout === 'classy') {
    <app-classy-layout></app-classy-layout>
}

@if (layout === 'onboarding') {
    <app-onboarding-layout></app-onboarding-layout>
}

<!-- Compact -->
@if (layout === 'compact') {
    <app-compact-layout></app-compact-layout>
}

<!-- Dense -->
@if (layout === 'dense') {
    <app-dense-layout></app-dense-layout>
}

<!-- Futuristic -->
@if (layout === 'futuristic') {
    <app-futuristic-layout></app-futuristic-layout>
}

<!-- Thin -->
@if (layout === 'thin') {
    <app-thin-layout></app-thin-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Settings drawer - Remove this to remove the drawer and its button -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- <app-settings></app-settings> -->
